import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class CREModalService {
  isOpen$ = new BehaviorSubject<boolean>(false);

  open(): void {
    this.isOpen$.next(true);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) {
      ionContent.style.setProperty("--overflow", "hidden");
    }
  }

  close(): void {
    this.isOpen$.next(false);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) {
      ionContent.style.removeProperty("--overflow");
    }
  }
}
